/**
 * Card Brand Enum
 */
export enum IconBrandEnum {
  visa = "visa",
  masterCard = "masterCard",
  diners = "diners",
  discover = "discover",
  amex = "amex",
  jcb = "jcb",
  carnet = "carnet",
}



// WEBPACK FOOTER //
// ./src/containers/Card/store/IconBrandEnum.ts